/// <amd-module name="WidgetCommon/WitUtils/UrlUtils" />
import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";
import { ActionParameters, ActionUrl } from "./Constants";

/*
 * This Utility was copied from vss-work-web/work-items-hub
 */

const QueriesRouteId = "ms.vss-work-web.query-route-basic";

/**
 * Gets the URL for the queries hub
 * @param fragment fragment (e.g. #_a=query&id=<guid>)
 */
export function getQueriesHubUrl(pageContext: IVssPageContext, projectName: string, fragment: string): string {
    const url = routeUrl(pageContext, QueriesRouteId, {
        project: projectName
    });
    return `${url}?${fragment}`;
}

/**
 * Gets the URL for queries hub with temp query id
 * @param tempQueryId id of temporary query
 */
export function getTempQueryUrl(pageContext: IVssPageContext, projectName: string, tempQueryId: string): string {
    const state = {
        [ActionUrl.ACTION]: ActionUrl.ACTION_QUERY,
        [ActionParameters.TEMPQUERYID]: tempQueryId
    };
    const queryParam = serializeState(state);
    return `${getQueriesHubUrl(pageContext, projectName, queryParam)}`;
}

function serializeState(state: { [key: string]: any }): string {
    const serialized = [];
    for (const key in state) {
        const value = state[key];
        if (value !== null && typeof value !== "undefined") {
            const entry = key === "action" ? "_a" : key;
            serialized.push(entry + "=" + encodeURIComponent(value));
        }
    }
    return serialized.join("&");
}
